export default "__VITE_ASSET__BPNM7Yzy__"